import { render } from "./CartHeaderBook.vue?vue&type=template&id=716a0a14"
import script from "./CartHeaderBook.vue?vue&type=script&lang=js"
export * from "./CartHeaderBook.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__